module.exports = __webpack_public_path__ + "img/infoBlue.7605b50b.png";